import * as React from 'react';
import { Box } from '@mui/material';
import Loading from '../../../../auxiliares/loading';
import MapInit from './mapInit'
import { options } from '@config';


const MapInitContainer = () => {
    const [items, setItems] = React.useState([]);
    const [loading, setLoading] = React.useState(true); 


    const handleListPoints = async () => {
        const response = await fetch((options.api.url + "point"), {
            method: 'GET',
            mode: "cors",
            headers: {
                'Content-Type': 'application/json'
            },
        });
    
        const data = await response.json();

        const items =  data.pointsSearched

        return items
    }

    React.useEffect(()=> {
        const db = handleListPoints().then((e) => {
            setItems(e);
            setLoading(false);
        });
    },[loading]);

    return (
        <Box>
            {loading ? <Loading/>: <MapInit items={items}/>}
        </Box>
    )
}

export default MapInitContainer;